import { createRef } from "react"

const useFocus = () => {
  const ref = createRef()
  const setFocus = () => ref.current &&ref.current.focus()
  return [ref, setFocus]
}

export default useFocus